export default "__VITE_ASSET__Cpotjnl5__"